const config = {
    API_URL: 'https://api.bill.lviv.ua/api/',
    APP_NAME: 'Wenet Billing Panel',
};

export default config;
